import JwtService from "@/core/services/jwt.service";
import { getSubdomain } from "@/core/services/api.service";
import { computed } from "vue";

export function useVersionSwitch() {
  const licenseId = getSubdomain(window.location.origin);

  const link = computed(() => {
    const url = process.env.VUE_APP_NEW_FRONTEND_DOMAIN;
    return url.replace("://{{licenseId}}", `://${licenseId}`);
  });

  const switchVersion = async () => {
    const token = JwtService.getToken();
    if (!token) return;

    let path = "/platform/auth-wait";

    const newWindow = window.open(link.value + path, "_blank");

    if (newWindow) {
      const sendTokenMessage = () => {
        try {
          newWindow.postMessage(
            {
              type: "INSTANCE_AUTH_TOKEN",
              token: token,
              origin: window.location.origin
            },
            link.value
          );
        } catch (error) {
          //
        }
      };

      const messageListener = event => {
        if (
          event.origin === link.value &&
          event.data?.type === "INSTANCE_WINDOW_READY"
        ) {
          sendTokenMessage();
          window.removeEventListener("message", messageListener);
        }
      };
      window.addEventListener("message", messageListener);

      // Clean up the listener after 10 seconds
      setTimeout(() => {
        window.removeEventListener("message", messageListener);
      }, 10000);
    }
  };

  return {
    switchVersion
  };
}
